import { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';

// TODO проверить необходимость этого класса
export class CustomAxiosError<T = any, D = any> extends Error implements AxiosError<any, any> {
    code?: string;
    config: AxiosRequestConfig = {};
    request: any;
    response?: AxiosResponse<T, D>;
    isAxiosError: boolean;
    status?: string;
    toJSON: () => object;

    constructor(message: string, responseBody: AxiosResponse<T, D>) {
        super(message);
        this.response = responseBody;
        this.isAxiosError = true;
        this.toJSON = () => ({});
    }
}
